import { tran } from '../../../translations/schema/TranslationSchema.ts';

export const OptionsTranslationSchema = tran.array(
  tran.object({
    label: tran.rte(),
  }),
);
